import { IMatchupList, INewsArticleList } from '@/store/modules/game/interfaces'
import Vue from 'vue'

export default {
  SET_NEWS: (state: IGameState, articles: INewsArticleList) => {
    Vue.set(state, 'newsArticles', articles)
  },
  SET_MATCHUPS: (state: IGameState, matchups: IMatchupList) => {
    Vue.set(state, 'matchups', matchups)
    Vue.set(state, 'listPending', false)
  },
  SET_PERSONALISED_MATCHUPS: (state: IGameState, matchups: IMatchupList) => {
    Vue.set(state, 'personalisedMatchups', matchups)
  },
  SET_SETTLEMENT_TIME: (state: IGameState, time: number) => {
    Vue.set(state, 'settlementTime', time)
  },
  CLEAR_MATCHUPS: (state: IGameState) => {
    Vue.set(state, 'matchups', null)
    Vue.set(state, 'listPending', false)
  },
}
